var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"release-container"}},[_c('div',{staticClass:"title-release"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_c('div',{staticClass:"content-release",domProps:{"innerHTML":_vm._s(_vm.data)}})])}
var staticRenderFns = []

export { render, staticRenderFns }